import React, { useState, useEffect, useRef } from 'react';
import './css/inbox.css';
import TopBar from './components/TopBar';
import axios from 'axios';
import { a$ } from 'react-router/dist/development/register-COAKzST_';

const conv_threads_ep = process.env.REACT_APP_BE_API_BASE_URL + "/api/conversation-threads";
const conv_threads_by_lead_ep = process.env.REACT_APP_BE_API_BASE_URL + "/api/conversation-threads/bylead/";
const send_msg_ep = process.env.REACT_APP_BE_API_BASE_URL + "/api/conversation-threads/send-message";
const ups_usr_rd_ep = process.env.REACT_APP_BE_API_BASE_URL + "/api/conversation-threads/upsert-user-chat-read";

// Sample data for the chat list
const initialCustomers = [
  // { id: 1, name: 'Deepak B.', message: 'Hi! I would like to buy headp', time: '12:12 p.m.', avatar: 'D' },
  // { id: 2, name: 'Yogesh L.', message: 'Hey', time: '12:12 p.m.', avatar: 'Y' },
 ] as any[];

// Sample data for a single conversation
type ConversationMessage = {
  type: string;
  text: string;
  createdDate: string;
  mediaUrl?: string | null;
  mediaType?: string | null;
  mimeType?: string | null;
};

const conversationHistory: ConversationMessage[] = [
  // { type: 'in', text: 'Hi! I would like to buy headphones' },
  // { type: 'out', text: 'How can I help you?' },
];

// Component for a single chat item in the list
const ChatListItem: React.FC<any> = ({ chat, active, onClick }) => {
  return (
    <div
      className={`p-4 flex items-center space-x-4 cursor-pointer transition-colors duration-200 ${
        active ? 'bg-blue-100' : chat.isNew ? 'bg-yellow-100' : 'hover:bg-gray-100'
      }`}
      onClick={() => onClick(chat)}
    >
      <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white ${
        active ? 'bg-blue-500' : chat.isNew ? 'bg-yellow-500' : 'bg-gray-400'
      }`}>
        {chat.avatar}
      </div>
      <div className="flex-1 overflow-hidden">
        <div className="flex justify-between items-center">
          <span className={`font-semibold text-sm truncate ${chat.isNew ? 'text-yellow-700' : ''}`}>{chat.name}</span>
          <span className="text-xs text-gray-500">{chat.createdDate}</span>
        </div>
        <p className="text-gray-600 text-xs truncate">{chat.message}</p>
        {chat.isNew && (
          <span className="inline-block mt-1 px-2 py-0.5 text-xs bg-yellow-300 text-yellow-900 rounded-full">New</span>
        )}
      </div>
    </div>
  );
};

function HTMLRenderer( htmlString : string ) {
  if (htmlString && htmlString.trim()!==''){
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
    
  } else {
    return <div></div>;
  }
}


const PAGE_SIZE = Number(process.env.REACT_APP_CHAT_PAGE_SIZE); // Number of chats to load per scroll
const MIDDLE_PAGE_SIZE = 5; // Number of messages to load per scroll



// Main ChatDashboard component
const ChatDashboard: React.FC = () => {
  const [activeCustomer, setActiveCustomer] = useState<any>({});
  const [customers, setCustomers] = useState(initialCustomers);
  const [customerSearch, setCustomerSearch] = useState('');
  const [message, setMessage] = useState('');
  const [statusMsg, setStatusMsg] = useState('');
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [conversation, setConversation] = useState(conversationHistory);
  const chatListRef = useRef<HTMLDivElement>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const [agentAssigned, setAgentAssigned] = useState({}) as any;

  const loggedInUserObj = JSON.parse(localStorage.getItem('loggedInUserObj') as any);

  const convBottomRef = useRef<HTMLDivElement | null>(null);

  const reduceheight = 230;

  const [loading, setLoading] = useState(false);

  const [attachment, setAttachment] = useState<File | null>(null);
  const [attachmentPreviewUrl, setAttachmentPreviewUrl] = useState<string | null>(null);
  const [showAttachmentOptions, setShowAttachmentOptions] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingDuration, setRecordingDuration] = useState(0);
  const [isCancelling, setIsCancelling] = useState(false);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const recordedChunksRef = useRef<Blob[]>([]);
  const recordingTimerRef = useRef<NodeJS.Timeout | null>(null);
  const isCancellingRef = useRef(false);

  const [browserTimeZone, setBrowserTimeZone] = useState('UTC');

  // Left pane
  const [customerPageNo, setCustomerPageNo] = useState(1);
  const [hasMoreCustomers, setHasMoreCustomers] = useState(true);

  // Middle pane
  const [conversationPageNo, setConversationPageNo] = useState(1);
  const [hasMoreConversation, setHasMoreConversation] = useState(true);

  // store object URLs created for media so we can revoke them later
  const mediaUrlsRef = useRef<string[]>([]);

  // download media blob and return object URL (or null on failure)
  const downloadMedia = async (mediaId: string | undefined, mimeType?: string) => {

    //console.log(`Downloading media from backend for mediaId: ${mediaId}`);
    if (!mediaId) return null;
    try {
      const resp = await axios.get(`${conv_threads_ep}/download-media/${mediaId}`, {
        headers: {
          'Authorization': process.env.REACT_APP_BE_API_BASIC_AUTH || '',
        },
        responseType: 'blob',
      });

      let url = URL.createObjectURL(resp.data as Blob);

      //console.log(`Whatsapp media ${mediaId}, URL: ${url} | mimeType: ${mimeType}`);
      mediaUrlsRef.current.push(url);

      return url;

    } catch (err) {
      console.error('Failed to download media', mediaId, err);
      return null;
    }
  };

  // revoke created object URLs on unmount
  useEffect(() => {
    return () => {
      mediaUrlsRef.current.forEach(u => {
        try { URL.revokeObjectURL(u); } catch(_) {}
      });
      mediaUrlsRef.current = [];
    };
  }, []);

  // Lazy load customers on scroll for left pane
  const handleCustomerListScroll = (e: React.UIEvent<HTMLDivElement>) => {
    //alert(1);
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollTop + clientHeight >= scrollHeight  && hasMoreCustomers) {
      setCustomerPageNo(prev => prev + 1);
    }
  };

  // Lazy load older messages in middle pane
  const handleConversationScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight  } = e.currentTarget;
    if (scrollTop === 0 && hasMoreConversation && activeCustomer?.leadId) {
      setConversationPageNo(prev => prev + 1);
    }
  };

  // Function to simulate sending a message
const handleSendMessage = async () => {
  if ((message.trim() || attachment) && activeCustomer && activeCustomer.contactNo) {
    setConversation(prev => [
      ...prev,
      { type: 'OUT', 
        text: message + (attachment ? ` [${attachment.name}]` : ''),
        createdDate: new Date().toISOString() 
      }
    ]);


    const formData = new FormData();
    formData.append('leadContactNo', activeCustomer.contactNo);
    formData.append('userId', loggedInUserObj.id);
    formData.append('leadId', activeCustomer.leadId);
    formData.append('leadName', activeCustomer.name);
    formData.append('conversationContent', message);
    if (attachment) {
      formData.append('file', attachment);
    }
    try {
      console.log(`formData to be sent: ${JSON.stringify(formData)}`);
      const { data } = await axios.post(send_msg_ep, formData, {
        headers: {
          'Authorization': process.env.REACT_APP_BE_API_BASIC_AUTH || '',
          'Content-Type': 'multipart/form-data',
        }
      });
      const assignedAgent = {
        "fullName": loggedInUserObj.fullName,
        "contactNumber": loggedInUserObj.contactNumber,
        "whatsappNumberId": loggedInUserObj.whatsappNumberId,
        "gender": loggedInUserObj.gender
      };
      setAgentAssigned(assignedAgent);
      setShowMessage(false);
    } catch (error: any) {
      console.error(`Message send error: ${error.status} | ${error} `);
      setStatusMsg(`Unable to send message.  ${error}`);
      setShowMessage(true);
    }
    setMessage('');
    setAttachmentWithPreview(null);
  } else {
    setStatusMsg('Unable to send message. Please contact support');
    setShowMessage(true);
  }
};

  // Function to handle customer's chat selection
  const handleCustomerClick = (chat: any) => {
    console.log(`Customer clicked: ${JSON.stringify(chat)}`);
    setLoading(true);
    setConversation([]); // Clear previous conversation
    setConversationPageNo(1); // Reset conversation paging
    setActiveCustomer(chat);
    setShowMessage(false);

    axios.get(conv_threads_by_lead_ep + chat.leadId, {
        headers: {
            'Authorization': process.env.REACT_APP_BE_API_BASIC_AUTH || '',
        }
    }).then(async (response) => {
      let latestMessageId = 0;
      const threads = ((response.data as any).conversationThreads as Array<any>) || [];
      const filtered = threads.filter((conv: any) => conv && (
        (typeof conv.conversationContent === 'string' && conv.conversationContent.trim() !== '') ||
        conv.mediaId // keep threads that have media even if content empty
      ));
      const ordered = filtered.sort((a: any, b: any) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime());
      const processed = await Promise.all(ordered.map(async (conv: any) => {
        latestMessageId = Math.max(latestMessageId, conv.id || 0);
        const mediaUrl = conv.mediaId ? await downloadMedia(conv.mediaId, conv.mimeType) : null;
        return {
          type: conv.type,
          text: conv.conversationContent || '',
          createdDate: conv.createdDate,
          mediaUrl,
          mediaType: conv.mediaType,
          mimeType: conv.mimeType,
        };
      }));
      if (processed.length > 0) setConversation(prev => [...prev, ...processed]);

      const lead = (response.data as any).lead;
      if (lead) {
        setActiveCustomer((prevChat: any) => ({
          ...prevChat,       // copy old properties
          sourceBody: lead.sourceBody || ''            // overwrite one property
        }));

      }

      // Upsert UserChatRead to mark messages as read 
      const upsertData = {  
        userId: loggedInUserObj.id,
        leadId: chat.leadId,
        lastReadMessageId: latestMessageId // Get this from the last message in the conversation
      }

      axios.post(ups_usr_rd_ep, upsertData, {
        headers: {
          'Authorization': process.env.REACT_APP_BE_API_BASIC_AUTH || '',
          'Content-Type': 'application/json',
        }
      });

      setAgentAssigned((response.data as any).lead ? (response.data as any).lead.assignedUser : {});
    });

    // Clear file attachment state and input
    setAttachmentWithPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    setLoading(false);
    chat.isNew = false; // mark chat as read

  };

  useEffect(() => {
    // Scroll to bottom whenever conversation updates
    if (convBottomRef.current) {
      convBottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [conversation]);

  
  
  useEffect(() => {
    const fetchChats = async () => {
      try {
        const response = await axios.get(conv_threads_ep, {
          headers: {
            'Authorization': process.env.REACT_APP_BE_API_BASIC_AUTH || '',
          },
          params: {
            page: customerPageNo,
            pageSize: PAGE_SIZE,
            userId: loggedInUserObj.id,
            search: customerSearch
          }
        });

        const newChats = (response.data as []).map((conv) => {
          const leadName: string = (conv['leadName'] as string) || 'Unknown';
          const createdDateObj = new Date(conv['createdDate']);
          const createdDate = !isNaN(createdDateObj.getTime()) ? createdDateObj.toISOString().split('T')[0] : '';
          return {
            id: conv['id'],
            leadId: conv['leadId'],
            name: leadName,
            message: conv['conversationContent'] || '',
            contactNo: conv['leadContactNo'] || '',
            createdDate: createdDate,
            avatar: leadName ? leadName.charAt(0) : '?',
            sourceBody: conv['sourceBody'] || '',
            isNew: conv['isNew'] || false // <-- set this from backend
          };
        });

        //console.log(`Fetched ${newChats.length} chats for page ${customerPageNo}`);

        setCustomers(prev => {
          if (customerPageNo == 1) {
            return newChats;
          } else {
            // Only append new chats that don't already exist
            const existingIds = new Set(prev.map(chat => chat.id));
            const newUniqueChats = newChats.filter(chat => !existingIds.has(chat.id));
            return [...prev, ...newUniqueChats];
          }
        });
        setHasMoreCustomers(newChats.length == PAGE_SIZE);
      } catch (error) {
        setHasMoreCustomers(false);
      }
    };

    fetchChats();

    
    // Set up the interval to refresh data every 30 seconds
    const intervalId = setInterval(fetchChats, Number(process.env.REACT_APP_DATA_REFRESH_INTERVAL)); // 10000 milliseconds = 10 seconds

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId); 
   

  }, [customerPageNo, customerSearch]);

  // Reset pagination when search changes
  useEffect(() => {
    setCustomerPageNo(1);
    setCustomers([]);
    setHasMoreCustomers(true);
  }, [customerSearch]);

  useEffect(() => {
    if (!activeCustomer || !activeCustomer.leadId && (customers && customers.length > 0)) {
      console.log(`Total customers length ${customers.length} `); //  will log updated array
      handleCustomerClick(customers[0]);
    }
  }, [customers]);


  useEffect(() => {
    if (!activeCustomer?.leadId) return;
    const fetchConversation = async () => {
      try {
        const response = await axios.get(conv_threads_by_lead_ep + activeCustomer.leadId +'?reqTime='+new Date(), {
          headers: {
            'Authorization': process.env.REACT_APP_BE_API_BASIC_AUTH || '',
          },
          params: {
            page: conversationPageNo,
            pageSize: MIDDLE_PAGE_SIZE,
          }
        });
        const data = response.data as { conversationThreads?: Array<any> };
        const threads = (data.conversationThreads as Array<any>) || [];
        const filtered = threads.filter((conv: any) => conv && (
          (typeof conv.conversationContent === 'string' && conv.conversationContent.trim() !== '') ||
          conv.mediaId
        ));
        const ordered = filtered.sort((a: any, b: any) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime());
        const newMessages = await Promise.all(ordered.map(async conv => ({
          createdDate: conv.createdDate,
          type: conv.type,
          text: conv.conversationContent || '',
          mediaUrl: conv.mediaId ? await downloadMedia(conv.mediaId, conv.mimeType) : null,
          mediaType: conv.mediaType,
          mimeType: conv.mimeType,
        })));
        console.log(`Fetched ${newMessages.length}`);
        setConversation(prev => conversationPageNo === 1 ? newMessages : [...newMessages, ...prev]);
        setHasMoreConversation(newMessages.length === MIDDLE_PAGE_SIZE);
      } catch (error) {
        setHasMoreConversation(false);
      }
    };
    fetchConversation();
    // eslint-disable-next-line
  }, [activeCustomer?.leadId, conversationPageNo]);

  // Reset conversation paging when chat changes
  useEffect(() => {
    setConversationPageNo(1);
    setHasMoreConversation(true);
  }, [activeCustomer?.leadId]);

  // Close attachment options when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.attachment-options')) {
        setShowAttachmentOptions(false);
      }
    };

    if (showAttachmentOptions) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showAttachmentOptions]);

  // Helper function to start recording timer
  const startRecordingTimer = () => {
    setRecordingDuration(0);
    recordingTimerRef.current = setInterval(() => {
      setRecordingDuration(prev => prev + 1);
    }, 1000);
  };

  // Helper function to stop recording timer
  const stopRecordingTimer = () => {
    if (recordingTimerRef.current) {
      clearInterval(recordingTimerRef.current);
      recordingTimerRef.current = null;
    }
  };

  // Helper function to format seconds into MM:SS
  const formatRecordingTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Helper function to format file size
  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // Helper function to get file type icon
  const getFileTypeIcon = (fileType: string) => {
    if (fileType.startsWith('image/')) {
      return '🖼️';
    } else if (fileType.startsWith('audio/')) {
      return '🎵';
    } else if (fileType === 'application/pdf') {
      return '📄';
    } else {
      return '📎';
    }
  };

  // Helper function to set attachment with preview URL
  const setAttachmentWithPreview = (file: File | null) => {
    // Clean up previous preview URL
    if (attachmentPreviewUrl) {
      URL.revokeObjectURL(attachmentPreviewUrl);
    }

    setAttachment(file);

    if (file && (file.type.startsWith('image/') || file.type.startsWith('audio/'))) {
      const previewUrl = URL.createObjectURL(file);
      setAttachmentPreviewUrl(previewUrl);
    } else {
      setAttachmentPreviewUrl(null);
    }
  };

  // Cleanup recording and preview URLs on unmount
  useEffect(() => {
    return () => {
      if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
        mediaRecorderRef.current.stop();
      }
      stopRecordingTimer();

      // Clean up preview URL
      if (attachmentPreviewUrl) {
        URL.revokeObjectURL(attachmentPreviewUrl);
      }
    };
  }, [attachmentPreviewUrl]);


  useEffect(() => {
    setBrowserTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  }, []);

  const spinnerStyle: React.CSSProperties = {
    width: "30px",
    height: "30px",
    border: "5px solid #f3f3f3",
    borderTop: "5px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    margin: "auto", // centers horizontally
  };

  const keyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  return (
    <>

      <TopBar onNavigate={() => { }} currentPage="Inbox" />

    <div className="inbox-container">
                
    <div className="bg-gray-100 min-h-screen p-4 sm:p-6 lg:p-8">
      {/* Filters and User Info */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-4 sm:space-y-0 mb-6">
        <div className="flex space-x-2">
          <button className="px-4 py-2 rounded-lg bg-blue-500 text-white font-semibold text-sm">All</button>
          <button className="px-4 py-2 rounded-lg bg-gray-300 text-gray-800 font-semibold text-sm">Needs attention</button>
          <button className="px-4 py-2 rounded-lg bg-gray-300 text-gray-800 font-semibold text-sm">20 sales</button>
          <button className="px-4 py-2 rounded-lg bg-gray-300 text-gray-800 font-semibold text-sm">1 support</button>
          <button className="px-4 py-2 rounded-lg bg-gray-300 text-gray-800 font-semibold text-sm">3</button>
        </div>
        <div className="text-right">
          <span className="text-sm font-semibold text-gray-700">User :-</span>
          <span className="text-xl font-bold text-gray-900 ml-2">{agentAssigned && agentAssigned.fullName}</span>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 h-full min-h-[calc(100vh-10rem)]">
        {/* Left Panel: Chat List */}
        <div className="col-span-12 lg:col-span-3 bg-white rounded-lg shadow-lg flex flex-col" style={{
            height: window.outerHeight - reduceheight,
            overflowY: "auto",
            border: "0px solid black",
            padding: "0px",
          }}>
          <div className="p-4 border-b border-gray-200">
            <div className="relative">
              <input
                type="text"
                placeholder="Search customers..."
                value={customerSearch}
                onChange={(e) => setCustomerSearch(e.target.value)}
                className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="mt-2 flex items-center justify-between">
              <span className="text-sm text-gray-500">{customers.length} chats</span>
              <div className="relative">
                <select className="pl-8 pr-4 py-1 text-sm rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option>sort by latest chat</option>
                </select>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V4a1 1 0 00-1-1H3zm0 2h14v2H3V5zm0 4h14v2H3V9zm0 4h14v2H3v-2z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
          </div>         
          <div className="flex-1 overflow-y-auto"
            onScroll={handleCustomerListScroll}
            ref={chatListRef}
          >
            {customers && customers.map(chat => (
              <ChatListItem
                key={chat.id}
                chat={chat}
                active={activeCustomer?.id === chat.id}
                onClick={handleCustomerClick}
              />
            ))}
            {!hasMoreCustomers && (
              <div className="text-center text-xs text-gray-400 py-2">No more chats</div>
            )}

            {hasMoreCustomers &&
              <>
                <style>{keyframes}</style> 
                <div style={spinnerStyle}></div>
              </>
            }
          </div>

        </div>

        {/* Middle Panel: Conversation */}
        <div className="col-span-12 lg:col-span-6 bg-white rounded-lg shadow-lg flex flex-col" style={{
            height: window.outerHeight - reduceheight,
            overflowY: "auto",
            border: "0px solid black",
            padding: "0px",
          }}>
          <div className="p-4 border-b border-gray-200 flex items-center justify-between">
            <div>
              <div className="text-sm">
                {
                  activeCustomer && activeCustomer.name && activeCustomer.name.trim()!=="" ? 
                  <h2 className="text-xl font-bold">{activeCustomer && activeCustomer.name && activeCustomer.name?.trim()!=="" && activeCustomer.name}</h2> 
                  :
                  <>
                    <h2 className="text-xl font-bold">
                      <style>{keyframes}</style> 
                      <div style={spinnerStyle}>&nbsp;</div>
                    </h2>
                  </>
                }
              </div> 
              {/* <div className="text-sm"><h6 >{activeChat?.contactNo}</h6></div> */}
              {/* <div>{activeChat?.sourceBody?.substring(0,40)}...</div> */}

            </div>
            <div className="hidediv flex space-x-2">
              <button className="px-3 py-1 text-sm rounded-md font-semibold">+Add tag</button>
              <button className="px-3 py-1 text-sm rounded-md bg-green-200 text-green-700 font-semibold">sales</button>
              <button className="px-3 py-1 text-sm rounded-md bg-red-200 text-red-700 font-semibold">mumbai</button>
            </div>
            
          </div>
          
          <div className="p-4 overflow-y-auto space-y-4"
            onScroll={handleConversationScroll} style={{ flex: 1, minHeight: 0 }}
          >
            {loading && 
              <>
                <style>{keyframes}</style> 
                <div style={spinnerStyle}></div>
              </>
            }

            {!hasMoreConversation ?
              <div className="text-center text-xs text-gray-400 py-2">No previous messages</div>
              :
              <>
                <h2 className="text-xl font-bold">
                  <style>{keyframes}</style>
                  <div style={spinnerStyle}>&nbsp;</div>
                </h2>
                <h2 className="text-center text-xs text-gray-400 py-2">Loading previos chats...</h2>
              </>
            }

            {conversation.map((msg, index) => (
              <>
                {index === 0 &&
                  <div ref={convBottomRef}></div>
                }
                <div key={index} className={`flex ${msg.type === 'OUT' || msg.type === 'A-OUT' ? 'justify-end' : 'justify-start'}`}>
                  <div className={`conversation p-4 rounded-lg max-w-xs ${msg.type === 'OUT' ? 'bg-blue-500 text-white rounded-tr-none' : msg.type === 'A-OUT' ? 'bg-orange-500 text-white rounded-tr-none' : 'bg-gray-200 text-gray-800 rounded-tl-none'}`}>
                    <p className="text-sm">{HTMLRenderer(msg.text)}</p>
                    {/* render media attachments if present */}
                    {msg.mediaUrl && msg.mediaType === 'image' && (
                      <div className="mt-2">
                        <img src={msg.mediaUrl} alt="attachment" className="w-20 h-20 object-cover rounded" />
                      </div>
                    )}
                    {msg.mediaUrl && msg.mediaType === 'audio' && (
                      <div className="mt-2">
                        <audio controls className="max-w-full">
                          <source src={msg.mediaUrl || undefined} type={msg.mimeType || undefined} />
                          Your browser does not support the audio element.
                        </audio>
                      </div>
                    )}
                    {msg.mediaUrl && msg.mediaType && msg.mediaType !== 'image' && msg.mediaType !== 'audio' && (
                      // Download link for other file types
                      <div className="mt-2">
                        <a href={msg.mediaUrl} download className="text-sm text-blue-600 hover:text-blue-800 underline flex items-center gap-1" title={`Download ${msg.mimeType || 'file'}`}>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                          </svg>
                          Download
                        </a>
                      </div>
                    )}                    

                    <p className="chat-time">
                      {new Date(msg.createdDate).toLocaleString('en-AE', {
                        timeZone: browserTimeZone || 'UTC',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: true,
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                      })}
                    </p>
                  </div>
                </div>
               </>
             ))} 

            {/* <div ref={convBottomRef}></div> */}
          </div>
          <div  />
          
          <div className="p-4 border-t border-gray-200 flex items-center space-x-4" >
            <input
              type="textarea"
              className="flex-1 px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="How can I help you?"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
            />

            <input
              type="file"
              accept="image/*,application/pdf"
              onChange={e => {
                setShowMessage(false);
                const file = e.target.files?.[0] || null;
                const maxFileSizeMB = 2; // 2 MB
                if (file && file.size > maxFileSizeMB * 1024 * 1024) { // 2 MB
                  //alert('File size should not exceed 2 MB.');
                  setStatusMsg(`File size should not exceed ${maxFileSizeMB} MB.`);
                  setShowMessage(true);
                  if (fileInputRef.current) fileInputRef.current.value = '';
                  setAttachmentWithPreview(null);
                  return;
                }
                setAttachmentWithPreview(file);
              }}
              className="hidden"
              style={{ display: 'none' }}
              id="file-upload"
              ref={fileInputRef}
            />
            <div className="relative attachment-options">
              <button
                type="button"
                onClick={() => setShowAttachmentOptions(!showAttachmentOptions)}
                className="px-3 py-2 bg-gray-200 rounded cursor-pointer hover:bg-gray-300"
                title="Attach file or record voice"
              >
                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path>
                </svg>
              </button>
              {showAttachmentOptions && (
                <div className="absolute top-full mt-2 left-0 bg-white border border-gray-300 rounded-lg shadow-lg p-2 min-w-[200px]">
                  <button
                    type="button"
                    onClick={() => {
                      document.getElementById('file-upload')?.click();
                      setShowAttachmentOptions(false);
                    }}
                    className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 rounded flex items-center gap-2"
                  >
                    📎 Attach File
                  </button>
                  <button
                    type="button"
                    onClick={async () => {
                      try {
                        const stream = await navigator.mediaDevices.getUserMedia({
                          audio: {
                            echoCancellation: true,
                            noiseSuppression: true,
                            autoGainControl: true
                          }
                        });

                        // Try WhatsApp-compatible MIME types (prioritize MP4/AAC for WhatsApp)
                        let mimeType = 'audio/mp4';
                        if (!MediaRecorder.isTypeSupported(mimeType)) {
                          mimeType = 'audio/aac';
                          if (!MediaRecorder.isTypeSupported(mimeType)) {
                            mimeType = 'audio/mpeg'; // MP3
                            if (!MediaRecorder.isTypeSupported(mimeType)) {
                              mimeType = 'audio/webm;codecs=opus'; // Fallback for other browsers
                              if (!MediaRecorder.isTypeSupported(mimeType)) {
                                mimeType = ''; // Let browser choose best available
                              }
                            }
                          }
                        }

                        const mediaRecorder = new MediaRecorder(stream, mimeType ? { mimeType } : {});
                        mediaRecorderRef.current = mediaRecorder;
                        recordedChunksRef.current = [];

                        mediaRecorder.ondataavailable = (event) => {
                          if (event.data.size > 0) {
                            recordedChunksRef.current.push(event.data);
                          }
                        };

                        mediaRecorder.onstop = () => {
                          // Only set attachment if not cancelling
                          if (!isCancellingRef.current && recordedChunksRef.current.length > 0) {
                            const audioBlob = new Blob(recordedChunksRef.current, { type: mediaRecorder.mimeType || 'audio/mp4' });
                            const extension = mediaRecorder.mimeType?.includes('mp4') ? 'mp4' :
                                            mediaRecorder.mimeType?.includes('aac') ? 'aac' :
                                            mediaRecorder.mimeType?.includes('mpeg') ? 'mp3' :
                                            mediaRecorder.mimeType?.includes('webm') ? 'webm' : 'mp4';
                            const audioFile = new File([audioBlob], `voice-recording-${Date.now()}.${extension}`, {
                              type: mediaRecorder.mimeType || 'audio/mp4'
                            });
                            setAttachmentWithPreview(audioFile);
                          }
                          setIsRecording(false);
                          setShowAttachmentOptions(false);
                          setIsCancelling(false); // Reset the state flag
                          isCancellingRef.current = false; // Reset the ref flag
                          stopRecordingTimer();
                          // Stop all tracks to free up the microphone
                          stream.getTracks().forEach(track => track.stop());
                        };

                        mediaRecorder.start();
                        setIsRecording(true);
                        setShowAttachmentOptions(false); // Close dropdown but keep recording active
                        setIsCancelling(false); // Ensure cancel flag is reset
                        isCancellingRef.current = false; // Reset ref flag
                        startRecordingTimer();
                      } catch (error) {
                        console.error('Error accessing microphone:', error);
                        alert('Could not access microphone. Please check permissions.');
                      }
                    }}
                    className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 rounded flex items-center gap-2"
                  >
                    🎤 Record Voice
                  </button>
                </div>
              )}
              {isRecording && (
                <div className="mt-3 p-3 bg-gradient-to-r from-red-50 to-red-100 border border-red-200 rounded-xl shadow-sm">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="flex items-center gap-2">
                        <div className="relative">
                          <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                          <div className="absolute inset-0 w-3 h-3 bg-red-500 rounded-full animate-ping opacity-75"></div>
                        </div>
                        <div className="flex items-center gap-1">
                          <svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path>
                          </svg>
                          <span className="text-sm font-medium text-red-700">Recording..</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <button
                        type="button"
                        onClick={() => {
                          if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
                            mediaRecorderRef.current.stop();
                          }
                        }}
                        className="flex items-center gap-2 px-4 py-2 bg-red-500 hover:bg-red-600 text-sm font-medium rounded-lg transition-all duration-200 shadow-sm hover:shadow-md transform hover:scale-105"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H9a1 1 0 01-1-1v-4z"></path>
                        </svg>
                        Stop
                      </button>
                      <button
                        type="button"
                        title="Cancel Recording"
                        aria-label="Cancel Recording"
                        onClick={() => {
                          // Cancel recording - stop but don't save
                          setIsCancelling(true);
                          isCancellingRef.current = true;
                          if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
                            mediaRecorderRef.current.stop();
                          }
                        }}
                        className="flex items-center gap-2 px-4 py-2 bg-gray-500 hover:bg-gray-600  text-sm font-medium rounded-lg transition-all duration-200 shadow-sm hover:shadow-md transform hover:scale-105"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                        
                      </button>
                    </div>
                  </div>
                  <div className="mt-2 flex items-center gap-1">
                    <div className="flex-1 bg-red-200 rounded-full h-1">
                      <div className="bg-red-500 h-1 rounded-full animate-pulse" style={{width: '60%'}}></div>
                    </div>
                    <span className="text-xs text-red-600 font-mono">{formatRecordingTime(recordingDuration)}</span>
                  </div>
                </div>
              )}
            </div>

            <button
            className="px-6 py-2 rounded-lg bg-blue-500 text-white font-semibold hover:bg-blue-600 transition-colors"
            onClick={handleSendMessage}
            >
            Send
            </button>



          </div>
                        {attachment && (
            <div className="mt-2 p-3 bg-gray-50 border border-gray-200 rounded-lg">
                <div className="flex items-center gap-3" >
                  {/* File Type Icon */}
                  <div className="text-2xl">
                    {getFileTypeIcon(attachment.type)}
                  </div>

                  {/* File Details */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-gray-900 truncate">
                        {attachment.name}
                      </span>
                      <span className="text-xs text-gray-500">
                        ({formatFileSize(attachment.size)})
                      </span>
                    </div>

                    {/* Image Preview */}
                    {attachment.type.startsWith('image/') && attachmentPreviewUrl && (
                      <div className="mt-2">
                        <img
                          src={attachmentPreviewUrl}
                          alt="Attachment preview"
                          className="object-cover rounded border"
                          style={{ width: '100px', height: '50px' }}
                        />
                      </div>
                    )}

                    {/* Audio Preview */}
                    {attachment.type.startsWith('audio/') && attachmentPreviewUrl && (
                      <div className="mt-2">
                        <audio
                          controls
                          className="w-full max-w-xs h-8"
                          preload="metadata"
                        >
                          <source src={attachmentPreviewUrl} type={attachment.type} />
                          Your browser does not support audio playback.
                        </audio>
                      </div>
                    )}
                  </div>

                  {/* Remove Button */}
                  <button
                    type="button"
                    onClick={() => setAttachmentWithPreview(null)}
                    className="p-1 text-gray-400 hover:text-red-500 transition-colors"
                    title="Remove attachment"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                </div>
              </div>
            )}
            {showMessage && (
              <div className={`p-4 flex items-center space-x-4 message-box ${message.includes('successful') ? 'success' : 'error'}`}
                role="alert" style={{ justifyContent: 'center' }}>
                {statusMsg}
              </div>
            )}

            
        </div>

        {/* Right Panel: User Details */}

          <div className="col-span-12 lg:col-span-3 bg-white rounded-lg shadow-lg p-6 flex flex-col space-y-4">
            <div className="text-center border-b border-gray-200 pb-4 mb-4">
              <div className="w-24 h-24 mx-auto rounded-full bg-gray-200 flex items-center justify-center text-4xl font-bold text-gray-600">
                {agentAssigned && agentAssigned.fullName ? agentAssigned.fullName.charAt(0) : '?'}
              </div>
              <h3 className="mt-2 text-xl font-bold text-gray-900"> {agentAssigned && agentAssigned.fullName ? 'Agent assigned: ' +agentAssigned.fullName.split(" ")[0]: 'No agent assigned'}</h3>
            </div>
            <div className="space-y-4 text-sm text-gray-700">
                {loading &&
                  <>
                    <p>
                      <style>{keyframes}</style>
                      <div style={spinnerStyle}>{loading}</div>
                    </p>
                  </>
                }
                <p><strong>Customer : {activeCustomer && activeCustomer?.name}</strong></p>
                <p><strong>Contact Number :{activeCustomer &&  activeCustomer?.contactNo}</strong></p>
                <p><strong>Source :{activeCustomer && activeCustomer?.sourceBody?.trim()!=='' && activeCustomer?.sourceBody?.substring(0,150)}...</strong></p>
                {/* <p><strong>Messenger Name :{agentAssigned.messengerName}</strong></p>
                <p><strong>Insta ID :{agentAssigned.instaId}</strong></p>
                <p><strong>Gender : {agentAssigned.gender && agentAssigned.gender==="M" ? "Male" : "Female"}</strong></p>
                <p><strong>Chat started :{agentAssigned.chatStarted}</strong></p> */}
            </div>

            <div className="hidediv border-t border-gray-200 pt-4 mt-4">
              <h4 className="text-md font-bold text-gray-900 mb-2">Buying History :-</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>Air Line Ticket - 2025.04.20</li>
                <li>UAE Visa - 2025.02.20</li>
                <li>Air Line Tickets - 2025.01.20</li>
              </ul>
            </div>
          </div>
      </div>
    </div>
    </div>
    </>
  );
};

// Main App component for demonstration
const Inbox: React.FC = () => {
  return (
    <>
      <script src="https://cdn.tailwindcss.com"></script>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap" rel="stylesheet" />
      <style>
        {`
          body {
            font-family: 'Inter', sans-serif;
          }
          /* Custom CSS for the chat bubbles and other elements */
          .chat-bubble-out {
              background-color: #3B82F6;
              color: #fff;
              border-top-right-radius: 0;
          }
          .chat-bubble-in {
              background-color: #E5E7EB;
              color: #1F2937;
              border-top-left-radius: 0;
          }
              
        `
        
        
        }
      </style>
      <ChatDashboard />
    </>
  );
};

export default Inbox;
